<mat-form-field>
  <span *ngIf="prefix" matPrefix>{{prefix}} &nbsp;</span>
  <input matInput [readonly]="isDisabled" [formControl]="inputControl" [placeholder]="placeholder"
    (blur)="handleInputBlur()" #inputElement>
  <span *ngIf="suffix" matSuffix>{{suffix}}</span>
</mat-form-field>